import React, { useState } from 'react';

import { Form as FinalForm, Field } from 'react-final-form';

import createStyles from '@guestyci/foundation/createStyles';
import Form from '@guestyci/foundation/next/Form';
import FormField from '@guestyci/foundation/next/FormField';
import FormGroup from '@guestyci/foundation/next/FormGroup';
import { FormProvider } from '@guestyci/foundation/enums';
import Input from '@guestyci/foundation/next/Input';
import Col from '@guestyci/foundation/next/Layout/Col';
import { email } from '@guestyci/foundation/validators';
import RaisedButton from '@guestyci/foundation/next/RaisedButton';
import TextField from '@guestyci/foundation/next/TextField';
import useTranslations from '@guestyci/localize/useTranslations';
import { forgotDio } from '../utils/eventsLogger';

import { getTranslations } from '../utils/translations';

import Subtitle from '../components/Subtitle';
import Title from '../components/Title';

import { resetPassword } from '../utils/api';

export const useStyles = createStyles(
  {
    form: {
      width: '70%',
    },
    submit: {
      margin: '32px auto 0',
    },
  },
  { name: 'ForgotForm' }
);

const translations = getTranslations({
  keyPrefix: 'auth_page:forgot.forgot_form',
  defaults: [
    ['title', 'Forgot password?'],
    ['subtitle', 'To reset your password, enter your email:'],
    ['generic_error', 'Incorrect email, please try again'],
    ['email_label', 'Email'],
    ['submit', 'RESET PASSWORD'],
    ['back_to_login', `Back to Login`],
  ],
});

const ForgotForm = ({ onResetSent }) => {
  const classes = useStyles();
  const [error, setError] = useState();
  const [
    title,
    subtitle,
    genericError,
    emailLabel,
    submit,
    backToLogin,
  ] = useTranslations(translations);

  const handleFormSubmit = async values => {
    try {
      forgotDio.track('reset_password', 'click');
      await resetPassword(values.email);
      onResetSent();
    } catch (e) {
      setError(genericError);
    }
  };

  return (
    <>
      <Col align="center" justify="center" spacing={1}>
        <Title>{title}</Title>
        <Subtitle color={error ? 'error' : 'default'}>
          {error || subtitle}
        </Subtitle>
      </Col>
      <FinalForm
        onSubmit={handleFormSubmit}
        initialValues={{}}
        render={({ handleSubmit, submitting }) => (
          <Form
            className={classes.form}
            onSubmit={handleSubmit}
            provider={FormProvider.Final}
            fieldInstance={Field}
          >
            <FormGroup>
              <FormField
                label={emailLabel}
                name="email"
                required
                validate={[email]}
              >
                <Input type="email" placeholder="name@company.com" />
              </FormField>
              <RaisedButton
                className={classes.submit}
                type="submit"
                disabled={submitting}
              >
                {submit}
              </RaisedButton>
            </FormGroup>
          </Form>
        )}
      />
      <TextField>
        <a href="./login">{backToLogin}</a>
      </TextField>
    </>
  );
};
export default ForgotForm;
